import {NazioneModel} from "../estremi-persona-fisica.model";

export class ModalitaPagamentoExtraSepaForm {
	existsDelegatoRiscossione: boolean;
	swift: string;
	banca: string;
	indirizzo: string;
	codiceContoPresent: boolean;
	codiceConto: string;
	iban: string;
	swiftBicPresent: boolean;
	nazione: NazioneModel;
	citta: string;
	zipCode: string;
}
